import { Component, inject, OnInit } from '@angular/core';
import { NtapGlobalConstants, Util, ViewState } from '@ntap/core';
import { map, Observable } from 'rxjs';
import { AuthService } from '../login.component';
import { ARHIV_POSJEDNIK } from '@app/shared/models/types';

@Component({
  selector: 'app-moja-institucija',
  templateUrl: './moja-institucija.component.html',
  styleUrls: ['./moja-institucija.component.scss']
})
export class MojaInstitucijaComponent implements OnInit {
  authService = inject(AuthService);
  viewState$: Observable<ViewState>;

  ngOnInit(): void {
    this.viewState$ = this.authService.validUser$.pipe(
      map((user) => {
        return {
          [Util.getFullAttrName(ARHIV_POSJEDNIK, NtapGlobalConstants.ATTR_id)]:
            user.maticnaInstitucijaId
        };
      })
    );
  }
}
